'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

require('./IndexFrame.less');

module.exports = Backbone.View.extend({

    el: '.IndexFrame',

    events: {
        'click .IndexFrame-menu-collapsed': 'onMenuCrossClick',
        'click .IndexFrame-logo': 'onLogoClick',
        'click .IndexFrame-scroll-progress-item': 'onScrollItemClick',
        'mouseenter .IndexFrame-bigText a': 'onBigTextMouseEnter',
        'mouseleave .IndexFrame-bigText a': 'onBigTextMouseLeave',
        'click .IndexFrame-policy span': 'onShowPolicyClick',
        'click .IndexFrame-policyPopup': 'onHidePolicyClick',
    },


    initialize: function (options) {
        _.bindAll(this, 'onSectionChangeStart', 'onSectionChangeEnd');

        this.transformBigText();

        this.cursor = new Cursor();

        options.page.on('section-change-start', this.onSectionChangeStart);
        options.page.on('section-change-end', this.onSectionChangeEnd);

        this.$el.show();
    },


    onScrollItemClick: function(e) {
        this.trigger('go-to-section', $(e.currentTarget).attr('data-index'));
    },


    onShowPolicyClick: function() {
        this.$('.IndexFrame-policyPopup').addClass('IndexFrame-policyPopup--visible');

        this.trigger('policy-shown');

        this.cursor.show();
    },


    onHidePolicyClick: function() {
        var sel = getSelected().toString();

        if (sel) return;

        this.$('.IndexFrame-policyPopup').removeClass('IndexFrame-policyPopup--visible');

        this.trigger('policy-hidden');

        this.cursor.hide();


        function getSelected() {
            if (window.getSelection) {
                return window.getSelection().toString();
            } else if (document.getSelection) {
                return document.getSelection().toString();
            } else {
                var selection = document.selection && document.selection.createRange();
                if (selection.text) {
                    return selection.text.toString();
                }
                return "";
            }
            return "";
        }
    },


    transformBigText: function() {
        this.$('.IndexFrame-bigText h2').each(function() {
            var $this = $(this).find('a');
            var text = $this.text();
            var characters = text.split('');

            $(this).attr('data-text', text);

            $this.empty();

            $.each(characters, function (i, el) {
                if (el == ' ') {el = '&nbsp;'};
                $this.append('<span>' + el + '</span>');
            });
        });
    },


    onSectionChangeStart: function(sectionIndex) {
        this.$el.attr('data-active', sectionIndex);

        this.$('.IndexFrame-menu').toggleClass('IndexFrame-menu--expanded', sectionIndex == 0 && window.innerWidth >= 1024);

        if (this.prevSectionIndex !== undefined) {
            this.$('.IndexFrame-bigText h2[data-index="' + this.prevSectionIndex + '"]').hide();

            var currentCharacters = this.$('.IndexFrame-bigText h2[data-index="' + this.prevSectionIndex + '"]').attr('data-text').split('');
            var newCharacters = this.$('.IndexFrame-bigText h2[data-index="' + sectionIndex + '"]').attr('data-text').split('');

            var $captionAnimation = $('<h2 class="IndexFrame-bigText-animation">');
            var $captionFrom = $('<div data-index="1">');
            var $captionTo = $('<div data-index="2">');

            $captionAnimation.append($captionFrom);
            $captionAnimation.append($captionTo);
            this.$('.IndexFrame-bigText').append($captionAnimation);

            $.each(currentCharacters, function (i, el) {
                if (el == ' ') {el = '&nbsp;'};
                $captionFrom.append('<span>' + el + '</span>');
            });

            $.each(newCharacters, function (i, el) {
                if (el == ' ') {el = '&nbsp;'};
                $captionTo.append('<span>' + el + '</span>');
            });

            $captionAnimation.outerHeight();

            $captionAnimation.addClass('IndexFrame-bigText-animation--animate');
        }

        this.prevSectionIndex = sectionIndex;
    },


    onSectionChangeEnd: function(sectionIndex) {
        this.$('.IndexFrame-bigText h2[data-index="' + sectionIndex + '"]').show();

        this.$('.IndexFrame-bigText-animation').remove();
    },


    onLogoClick: function() {
        this.trigger('go-to-first');
    },


    onMenuCrossClick: function() {
        this.$('.IndexFrame-menu').addClass('IndexFrame-menu--expanded');
    },


    onBigTextMouseEnter: function() {
        this.$('.IndexFrame-nextArrow').addClass('IndexFrame-nextArrow--hovered');
    },


    onBigTextMouseLeave: function() {
        this.$('.IndexFrame-nextArrow').removeClass('IndexFrame-nextArrow--hovered');
    }
});



var Cursor = Backbone.View.extend({

    events: {
        'mouseenter': 'onMouseEnter',
        'mousemove': 'onMouseMove',
        'mouseleave': 'onMouseLeave',
    },


    initialize: function(params) {

        this.setElement($('.IndexFrame-policyPopup-content'));

        this.$cursor = $('.IndexFrame-cursor');
    },


    show: function() {
        this.$cursor.removeClass('invisible');

        if (app.mouse) {
            this.onMouseMove({
                pageX: app.mouse.x,
                pageY: app.mouse.y,
            });
        }
    },


    hide: function() {
        this.$cursor.addClass('invisible');
    },


    onMouseEnter: function() {
        this.$cursor.removeClass('outscreen');
    },


    onMouseMove: function(e) {
        this.$cursor.css({
            'transform': 'translate(' + e.pageX + 'px, ' + e.pageY + 'px)',
        });
    },


    onMouseLeave: function() {
        this.$cursor.addClass('outscreen');
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexFrame/IndexFrame.js
 ** module id = 22
 ** module chunks = 0
 **/